// The grid editor's live state (slice 07), shared by the properties panel
// (React) and the board (outside React): whether setup is on, which line is
// selected, and the DM's DRAFT grid during a drag — the cascade previewed on
// every frame, committed as one event on release (design/21 §3), so players
// see the finished grid once. Nothing here touches the socket.
import type { Grid } from '@dragons-table/vtt-shared';

export interface Selection {
  axis: 'x' | 'y';
  index: number;
}

export interface GridEditorState {
  setupOn: boolean;
  selected: Selection | null;
  /** The grid as it is mid-drag; null when nothing is being dragged. */
  draft: Grid | null;
  /** Drawing an area left ungridded (issue 1035): the next drag on the board is its rectangle. */
  drawingBlank?: boolean;
}

type Listener = (state: GridEditorState) => void;

let state: GridEditorState = { setupOn: false, selected: null, draft: null };
const listeners = new Set<Listener>();

const set = (next: Partial<GridEditorState>) => {
  state = { ...state, ...next };
  for (const l of listeners) l(state);
};

export const gridEditor = {
  get: () => state,
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
  setSetup(on: boolean): void { set({ setupOn: on, selected: on ? state.selected : null, draft: null, drawingBlank: false }); },
  select(selection: Selection | null): void { set({ selected: selection }); },
  draft(grid: Grid | null): void { set({ draft: grid }); },
  drawBlank(on: boolean): void { set({ drawingBlank: on }); },
  reset(): void { set({ setupOn: false, selected: null, draft: null, drawingBlank: false }); },
};
